export const listingAgentInitials = (name) => {
  const parts = String(name || "?").trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "?";
  return parts.map((n) => n[0]).join("").slice(0, 2).toUpperCase();
};

const ListingAgentAvatar = ({ name, avatarUrl, className = 'listing-agent-avatar' }) => (
  <div className={className} aria-hidden="true">
    {avatarUrl ? (
      <img src={avatarUrl} alt="" />
    ) : (
      listingAgentInitials(name)
    )}
  </div>
);

export default ListingAgentAvatar;
